import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../contexts/AuthContext';
import { jobTypeShort } from '../constants/jobTypes';

const CATEGORIES = [
  { name: '法律合规', key: 'legal', desc: '涉外法律、合规、风控' },
  { name: '财务审计', key: 'finance', desc: '跨境财务、税务、审计' },
  { name: '商务拓展', key: 'business', desc: '海外BD、市场开拓' },
  { name: '工程技术', key: 'engineering', desc: '海外工程、技术管理' },
  { name: '人力资源', key: 'hr', desc: '海外HR、组织发展' },
  { name: '供应链',   key: 'supply-chain', desc: '跨境物流、采购' },
];

function Home() {
  const { user } = useAuth();
  const [search, setSearch] = useState('');
  const [recentJobs, setRecentJobs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/jobs?limit=9').then(res => setRecentJobs(res.data.jobs || [])).catch(() => {});
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/jobs?search=${encodeURIComponent(search)}`);
  };

  return (
    <div>
      {/* Hero */}
      <section className="hero">
        <div className="container">
          <h1 className="hero-title">
            撸起袖子 · <span>连接全球机会</span>
          </h1>
          <p className="hero-desc">
            专注于中国背景候选人的涉外岗位平台
          </p>

          <form onSubmit={handleSearch} className="search-bar">
            <input
              type="text"
              placeholder="搜索岗位、公司、关键词..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <button type="submit" className="btn btn-primary btn-sm">搜索</button>
          </form>

          <div className="hero-actions" style={{ marginTop: 12 }}>
            <Link to="/jobs" className="btn btn-ghost btn-sm">浏览全部岗位</Link>
            <Link to="/candidates" className="btn btn-ghost btn-sm">人才广场</Link>
          </div>
        </div>
      </section>

      {/* Categories - 紧凑版 */}
      <section className="section section-compact">
        <div className="container">
          <h2 className="section-title">岗位类别</h2>
          <div className="category-chip-row">
            {CATEGORIES.map(cat => (
              <Link
                key={cat.key}
                to={`/jobs?category=${cat.key}`}
                className="category-chip"
                title={cat.desc}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Recent Jobs */}
      {recentJobs.length > 0 && (
        <section className="section section-compact" style={{ background: 'var(--border-light)' }}>
          <div className="container">
            <h2 className="section-title">最新岗位</h2>
            <div className="grid-3">
              {recentJobs.map(job => (
                <Link key={job.id} to={`/jobs/${job.id}`} style={{ textDecoration: 'none' }}>
                  <div className="card card-clickable job-card job-card-compact">
                    <div className="job-card-content">
                      <div className="job-card-title">{job.title}</div>
                      <div className="job-card-company">{job.company}</div>
                      <div style={{ fontSize: '0.78rem', color: 'var(--text-light)', margin: '2px 0' }}>
                        {job.location}
                        {job.publishDate && <span style={{ marginLeft: 8 }}>· {job.publishDate}</span>}
                      </div>
                      <div className="job-card-meta">
                        <span className="tag">{jobTypeShort(job.jobType)}</span>
                        {job.salary && <span style={{ fontSize: '0.78rem', color: 'var(--accent)', fontWeight: 600 }}>{job.salary}</span>}
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <Link to="/jobs" className="btn btn-primary btn-sm">查看更多岗位</Link>
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section className="section section-compact" style={{ textAlign: 'center' }}>
        <div className="container">
          <h2 className="section-title">准备好了吗？</h2>
          <p className="section-subtitle">无论你是招聘方还是求职者，RollSleeves 都是你的最佳起点</p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
            <Link to="/post-job" className="btn btn-primary btn-lg">发布岗位</Link>
            <Link to={user ? "/my-profile" : "/register"} className="btn btn-accent btn-lg">创建个人资料</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
